import React, { DetailedHTMLProps, ForwardedRef, forwardRef, InputHTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export type CheckboxProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  className?: string
}
export const Checkbox = forwardRef(
  ({ className, ...props }: CheckboxProps, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <input
        autoComplete="off"
        className={twMerge(
          'form-check-input cursor-pointer appearance-none rounded-[4px] border-[2px] border-gray-300 bg-white bg-contain bg-center bg-no-repeat align-top leading-7 text-primary transition duration-200 checked:border-primary checked:bg-primary focus:outline-none focus:ring-primary',
          className,
        )}
        type="checkbox"
        {...props}
        ref={ref}
      />
    )
  },
)
Checkbox.displayName = 'Checkbox'

export default Checkbox
